import lineDefinition from '../utils/LineDefinition.json';
import googleDefinition from '../utils/GoogleDefinition.json';

import _ from 'lodash';

export const excelSheets = [
  {
    original_name: 'LINE_DAILY',
    name: '每日',
    selected: true
  },
  {
    original_name: 'LINE_DAILY_CAMPAIGN',
    name: '每日(廣告活動)',
    selected: false
  },
  {
    original_name: 'LINE_MONTHLY',
    name: '月份',
    selected: false
  },
  {
    original_name: 'LINE_CAMPAIGN_CREATIVE',
    name: '廣告活動-素材-圖片',
    selected: false
  },
  {
    original_name: 'LINE_CAMPAIGN_CREATIVE_VDO',
    name: '廣告活動-素材-影片',
    selected: false
  },
  {
    original_name: 'LINE_CREATIVE',
    name: '素材',
    selected: true
  },
  {
    original_name: 'LINE_ADSET_CREATIVE',
    name: '廣告群組-素材-圖片',
    selected: false
  },
  {
    original_name: 'LINE_ADSET_CREATIVE_VDO',
    name: '廣告群組-素材-影片',
    selected: false
  },
  {
    original_name: 'LINE_CAMPAIGN',
    name: '廣告活動',
    selected: false
  },
  {
    original_name: 'LINE_CAMPAIGN_ADSET',
    name: '廣告活動-廣告群組',
    selected: false
  },
  {
    original_name: 'LINE_AUDIENCE',
    name: '受眾',
    selected: true
  },
  {
    original_name: 'LINE_GENDER',
    name: '性別',
    selected: true
  },
  {
    original_name: 'LINE_GENDER_CAMPAIGN',
    name: '性別(廣告活動)',
    selected: false
  },
  {
    original_name: 'LINE_GENDER_CAMPAIGN_ADSET',
    name: '性別(廣告活動+群組)',
    selected: false
  },
  {
    original_name: 'LINE_AGE',
    name: '年齡',
    selected: true
  },
  {
    original_name: 'LINE_AGE_CAMPAIGN',
    name: '年齡(廣告活動)',
    selected: false
  },
  {
    original_name: 'LINE_AGE_CAMPAIGN_ADSET',
    name: '年齡(廣告活動+群組)',
    selected: false
  },
  {
    original_name: 'LINE_INTEREST',
    name: '興趣',
    selected: false
  },
  {
    original_name: 'LINE_ACT',
    name: '行為',
    selected: false
  },
  {
    original_name: 'LINE_STATUS',
    name: '個人狀態',
    selected: false
  },
  {
    original_name: 'LINE_PURCHASE_INTENT',
    name: '購買意願',
    selected: false
  },
  {
    original_name: 'LINE_PLACEMENT',
    name: '版位',
    selected: false
  },
  {
    original_name: 'LINE_PLACEMENT_CAMPAIGN',
    name: '版位(廣告活動)',
    selected: false
  },
  {
    original_name: 'LINE_PLACEMENT_CAMPAIGN_ADSET',
    name: '版位(廣告活動+群組)',
    selected: false
  },
  {
    original_name: 'LINE_REGION',
    name: '地區',
    selected: false
  }
]

export const origiTargetName = [
  {
    "campaignGoalName": "加好友廣告",
    "campaignGoalEng": "friend"
  },
  {
    "campaignGoalName": "網站導流_網站轉換",
    "campaignGoalEng": "web"
  },
  {
    "campaignGoalName": "曝光目標_觸及目標",
    "campaignGoalEng": "target"
  },
  {
    "campaignGoalName": "影片觀看目標",
    "campaignGoalEng": "video"
  }
]


//自定義指標欄位
const initializeCustomFields = [
  {
    category: 'custom',
    name: '自定義指標',
    child: []
  }
]

//排序欄位
const fieldsSort = lineDefinition.sort((a, b) => {
  return a.categoryIndex - b.categoryIndex;
});

//非固定欄位
const filterFieldsData = fieldsSort.filter((el) => {
  return el.categoryName !== "固定欄位";
})

//欄位(回傳格式)
export const generalData = filterFieldsData.map((edition, index) => {
  return {
    name: edition.name,
    expression: edition.lineapi,
    format: edition.format,
    type: edition.type,
    sheet: edition.excel,
    indexNumber: index,
  }
})

//欄位(顯示分類)
const fixedFields = Array.from(
  new Set(filterFieldsData.map((s) => s.categoryName))
).map((lab, index) => {
  return {
    category: `${lab}_${index}`,
    name: lab,
    child: filterFieldsData.filter((s) => s.categoryName === lab)
      .map((edition) => {
        return {
          name: edition.name,
          expression: edition.lineapi,
          format: edition.format,
          type: edition.type,
          sheet: edition.excel,
        }
      })
  }
})

// export const allFixedFields = initializeCustomFields.concat(fixedFields);
export const allFixedFields = fixedFields;

export const defaultEmailSelectedMetric = {
  type: "CONVERSION_1",
  creativeFields: [
    {
      expression: "Impressions",
      format: "INTEGER",
      name: "曝光數",
      sheet: ['friend', 'web', 'target', 'video'],
      type: "DEFAULT"
    },
    {
      expression: "Clicks",
      format: "INTEGER",
      name: "點擊數",
      sheet: ['friend', 'web', 'target'],
      type: "DEFAULT"
    }
  ]
}

// export const customData = [
//   {
//     "category": "轉換動作自訂欄",
//     "cid": "A50866261441",
//     "cidname": "*C-妮娜有限公司-Conas 妮娜巧克力",
//     "id": "123456-1",
//     "name": "購物車鈕",
//     "status": "ENABLED",
//     "type": "DEFAULT"
//   },
//   {
//     "category": "轉換動作自訂欄",
//     "cid": "A50866261441",
//     "cidname": "*C-妮娜有限公司-Conas 妮娜巧克力",
//     "id": "123456-2",
//     "name": "登入頁面",
//     "status": "ENABLED",
//     "type": "DEFAULT"
//   },
//   {
//     "category": "轉換動作自訂欄",
//     "cid": "A50866261441",
//     "cidname": "*C-妮娜有限公司-Conas 妮娜巧克力",
//     "id": "123456-3",
//     "name": "填寫付款資訊",
//     "status": "ENABLED",
//     "type": "DEFAULT"
//   }
// ]

export const TEST_CAMPAIGN = [
  {
    campaignObjective: "web",
    cid: "A73441246859",
    cidname: null,
    id: "5078732412003",
    name: "0824-0911，500【TLA22030903】3萬，日500，60天，0510---"
  },
  {
    campaignObjective: "friend",
    cid: "A73441246860",
    cidname: null,
    id: "5078732412004",
    name: "【生活好享貸】[CPC] 9/18-10/17，30天，日$3067，總$92009"
  },
]

